import { EXPOSURE_REBUILD_IN_PROGRESS_TOAST_ID } from '@app/constants/service';
import i18n, { NAMESPACE } from '@app/i18n';
import { toaster } from '@chakra-primitives/toaster';

const pending = new Set<string>();
const settledEarly = new Set<string>();

export const trackExposureRebuild = (rebuildId?: string): void => {
  if (!rebuildId || settledEarly.delete(rebuildId)) return;
  pending.add(rebuildId);
};

export const showExposureRebuildWaiting = async (): Promise<void> => {
  if (pending.size === 0) return;

  await i18n.loadNamespaces([NAMESPACE.EXPOSURES]);

  // The last rebuild can finish inside that await, and raising the spinner then would strand it.
  if (pending.size === 0) return;

  toaster.create({
    id: EXPOSURE_REBUILD_IN_PROGRESS_TOAST_ID,
    type: 'loading',
    description: i18n.t(`${NAMESPACE.EXPOSURES}:rebuildInProgress`),
    // Closable because a missed completion event (e.g. a dropped websocket) would otherwise strand it.
    // This can be phased out if we build a status endpoint to re-evaluate the rebuild progress.
    meta: { closable: true },
    onStatusChange: ({ status, src }) => {
      if (status === 'dismissing' && src !== 'programmatic') pending.clear();
    },
  });
};

export const settleExposureRebuild = (rebuildId?: string): void => {
  if (!rebuildId) return;
  if (!pending.delete(rebuildId)) {
    settledEarly.add(rebuildId);
    return;
  }
  if (pending.size === 0) {
    toaster.dismiss(EXPOSURE_REBUILD_IN_PROGRESS_TOAST_ID);
  }
};
